<template>
    <div class="p-5"><i class="fas fa-spinner fa-spin mr-2"></i>Please wait...</div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {client as http, axiosInstance} from "@/http_client";

    export default {
        methods: {
            ...mapActions(['loginRelay'])
        },
        mounted() {
            // Set token for /me call
            axiosInstance.defaults.headers.common['Authorization'] = this.$route.query.token;

            http.get('/app/users/me', {force: true}).then(response => {
                // Set with all data
                this.loginRelay({...response.data, token: this.$route.query.token});
                this.$router.push('/dashboard');
            });
        }
    };
</script>

<style scoped>

</style>
